import { createTRPCClient, httpBatchLink } from "@trpc/client";
import superjson from "superjson";
import type { AppRouter } from "@pessoas/api/src/routers.js";

/**
 * Cliente tRPC tipado a partir do router do servidor.
 *
 * O tipo atravessa a fronteira sem duplicação: mudar um campo na API quebra o
 * typecheck da web, e não a tela do usuário em produção.
 */
export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: "/trpc",
      transformer: superjson,
      headers() {
        const empresa = localStorage.getItem("eop:empresa");
        // Colaborador não troca de empresa por header: o servidor resolve o
        // vínculo. O header serve à web administrativa, e o servidor confere.
        return empresa ? { "x-tenant-id": empresa } : {};
      },
    }),
  ],
});
